module.exports = __webpack_public_path__ + "static/media/CU_LOGO.9d7ad317.f0dbfbfb.jpg";